import {
  Breadcrumbs,
  Grid,
  Link,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import Styles from "../Styles/index.module.css";
import CmmTable from "./CmmTable";
import logo from "../../../../images/Group 1000000833.png"
import Swal from "sweetalert2";
import { UploadFile } from "./UploadFile";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useStateValue } from "../../../../Hooks/stateProvider";
import Loader from "../../../../Loader/Loader";
import { CreateColumns, CreateColumnsModal } from "./CreateColumns";
import PreviewModal from "./PreviewModal";
import { ls } from "../../../../variables";
import { encrypt } from "../../../../utils/cipher";
import SelectComponent from "../../../../components/SelectComponent";
import { errorHandler } from "../../../../utils/errorHandling";
import { previewValidators } from "../../../../utils/validators";
import { alert } from "../../../../utils/sweetAlert";
const CmmPage = (props) => {
const navigate = useNavigate();
  const [{ uploadType, uploadTrigger, cmmType, pageLoading }, dispatch] = useStateValue();
  const [selectedCompliance, setSelectedCompliance] = useState("");
  const [isPreviewClicked, setIsPreviewClicked] = useState(false);
  const [selectedQuarter, setSelectedQuarter] = useState("");
  const [selectedHalfYearly, setSelectedHalfYearly] = useState("");
  // const [selectedUploadType, setSelectedUploadType] = useState(uploadType);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [uploadFlag, setUploadFlag] = useState(false);
  const [formResult, setFormResult] = useState([]);
  const [compliance, setCompliance] = useState([]);
  const [gridData, setGridData] = useState();
  const [open, setOpen] = useState(false);
  const [finalSubmit, setFinalSubmit] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [filteredRows, setFilteredRows] = useState();
  const [searchQuery, setSearchQuery] = useState("");

  // const userType = ls.get("userType");
  const pmsName = ls.get("pmsName");

  const handlePreviewData = async () => {
    let payload;
    if (props.type === "cmm") {
      payload = {
        pmsName: pmsName,
        fy_year: selectedFinancialYear,
        quarter: selectedQuarter,
        fileType: "CMM",
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
    } 
    // else {
    //   payload = {
    //     pmsName: pmsName,
    //     fy_year: selectedFinancialYear,
    //     half_year: selectedHalfYearly,
    //     fileType: "HYTR",
    //     authToken: ls.get("authToken"),
    //     refreshToken: ls.get("refreshToken")
    //   };
    // }
    setIsPreviewClicked(true);
    dispatch({ type: "SHOW_LOADER" });
    const encryptedPayload = await encrypt(payload)
    axios
      .post("api/pms/previewPage", { payload: encryptedPayload })
      .then((response) => {
        setIsPreviewClicked(true);
        let tempObj = {},
          mappedDataArray = [];
        if (props.type == "cmm") {
          if (response.data.value.length > 0) {
            response.data.value.map((element, index) => {
              element.id = index + 1;
              tempObj[element.cmm_type] = [
                ...(tempObj[element.cmm_type] || []),
                element,
              ];
            });
            Object.keys(tempObj).map((ele, index) => {
              mappedDataArray.push({
                label: ele,
                rows: tempObj[ele],
                columns: CreateColumnsModal(
                  Object.keys(tempObj[ele][0]),
                  ele,
                  props.type
                ),
              });
            });
            setPreviewData(mappedDataArray);
            dispatch({ type: "HIDE_LOADER" });
            setOpen(true);
            dispatch({ type: "fileName", fileName: "" })
            dispatch({ type: "fileDetails", fileDetails: {} })
          }
        } else {
          if (response.data.value.length > 0) {
            response.data.value.map((element, index) => {
              element.id = index + 1;
              tempObj["HYTR Module"] = [
                ...(tempObj["HYTR Module"] || []),
                element,
              ];
            });
            Object.keys(tempObj).map((ele, index) => {
              mappedDataArray.push({
                label: ele,
                rows: tempObj[ele],
                columns: CreateColumnsModal(
                  Object.keys(tempObj[ele][0]),
                  ele,
                  props.type
                ),
              });
            });
            setPreviewData(mappedDataArray);
            dispatch({ type: "HIDE_LOADER" });
            setOpen(true);
            dispatch({ type: "fileName", fileName: "" })
            dispatch({ type: "fileDetails", fileDetails: {} })
          }
        }
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        console.log("error:", err);
        errorHandler(err, navigate);
      });
  };

  const handleValidation = async (resetFlag) => {
    let payload;
    setCompliance([]);
    if (props.type === "cmm") {
      payload = {
        pmsName: pmsName,
        fy_year: selectedFinancialYear,
        // quarter: selectedQuarter,
        fileType: "CMM",
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
    }
    dispatch({ type: "SHOW_LOADER" });
    resetFlag ? setIsPreviewClicked(true) : setIsPreviewClicked(false);
    if (formResult.length > 0) {
      setIsPreviewClicked(true)
    }
    setUploadFlag(false);
    const encryptedPayload = await encrypt(payload)
    axios.post("api/pms/validationcmmHytr", { payload: encryptedPayload }).then((response) => {
      setIsPreviewClicked(true);
      if (response.data.success) {
        setUploadFlag(false);
        if (response.data.res.length > 0) {
          let tempObj = {}, mappedDataArray = [];
          if (props.type == "cmm") {
            response.data.res.map((element, index) => {
              element.id = index + 1;
              tempObj[element.cmm_type] = [
                ...(tempObj[element.cmm_type] || []),
                element,
              ];
            });
            Object.keys(tempObj).map((ele, index) => {
              mappedDataArray.push({
                label: ele,
                rows: tempObj[ele],
                columns: CreateColumns(
                  Object.keys(tempObj[ele][0]),
                  ele,
                  props.type
                ),
              });
            });
            dispatch({ type: "HIDE_LOADER" });
            setFormResult(mappedDataArray);
            // setOpen(true)
          } 
        } else {
          setIsPreviewClicked(false);
          dispatch({ type: "HIDE_LOADER" });
          setFormResult([])
          setGridData()
          setFilteredRows()
          setUploadFlag(false);
          Swal.fire({
            title: `Report already uploaded on ${response.data.uploadDate}`,
            html: `<span style="font-weight: bold;">Download copy of submission using download button</span>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#154063",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancel",
            confirmButtonText: "Download",
            customClass: {
              confirmButton: Styles.btnConfirm
            }
          }).then(async (result) => {
            if (result.isConfirmed) {
              const downloadPayload = {
                s3Location: response.data.s3Location,
                moduleType: props.type.toUpperCase(),
                authToken: ls.get("authToken"),
                refreshToken: ls.get("refreshToken")
              };
              let encryptedPayload = await encrypt(downloadPayload)
              axios
                .post(
                  "/api/pms/downloadReport",
                  { payload: encryptedPayload }
                )
                .then((val) => {
                  window.open(val.data.data, "_self");
                })
                .catch((err) => {
                  errorHandler(err, navigate)
                });
            }
          });
        }
      } else {
        if (uploadType == "Form") {
          setUploadFlag(false);
          setFormResult([])
          setGridData()
          setFilteredRows()
          handleFetchFormData();
        } else {
          dispatch({ type: "HIDE_LOADER" });
          setUploadFlag(true);
          setIsPreviewClicked(true);
          setFormResult([])
          setGridData()
          setFilteredRows()
        }
      }
    }).catch((err) => {
      dispatch({ type: "HIDE_LOADER" });
      errorHandler(err, navigate);
    })
  };

  const handleFetchFormData = async () => {
    let payload;
    if (props.type === "cmm") {
      payload = {
        pmsName: pmsName,
        fy_year: selectedFinancialYear,
        quarter: selectedQuarter,
        fileType: "CMM",
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };
    } 
    // else {
    //   payload = {
    //     pmsName: pmsName,
    //     fy_year: selectedFinancialYear,
    //     half_year: selectedHalfYearly,
    //     fileType: "HYTR",
    //     authToken: ls.get("authToken"),
    //     refreshToken: ls.get("refreshToken")
    //   };
    // }
    dispatch({ type: "SHOW_LOADER" });
    setIsPreviewClicked(false);
    const encryptedPayload = await encrypt(payload)
    axios
      .post("api/pms/fillForm", { payload: encryptedPayload })
      .then((response) => {
        setIsPreviewClicked(true);
        if (response.data.success) {
          fetchCurrentData()
        }
        else {
          alert("Oops...", "Something went wrong!", "error")
          dispatch({ type: "HIDE_LOADER" });
        }
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        console.log("error:", err)
        errorHandler(err, navigate)
      })
  };

  const fetchCurrentData = async () => {
    let payload;
    if (props.type === "cmm") {
      payload = {
        pmsName: pmsName,
        fy_year: selectedFinancialYear,
        quarter: selectedQuarter,
        fileType: "CMM",
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      };

     
    } 

    dispatch({ type: "SHOW_LOADER" });
    const encryptedPayload = await encrypt(payload)
    axios
      .post("api/pms/previewPage", { payload: encryptedPayload })
      .then((response) => {
        setIsPreviewClicked(true);
        let tempObj = {},
          mappedDataArray = [];
        if (props.type == "cmm") {
          if (response.data.value.length > 0) {
            response.data.value.map((element, index) => {
              element.id = index + 1;
              tempObj[element.cmm_type] = [
                ...(tempObj[element.cmm_type] || []),
                element,
              ];
            });
            Object.keys(tempObj).map((ele, index) => {
              mappedDataArray.push({
                label: ele,
                rows: tempObj[ele],
                columns: CreateColumns(
                  Object.keys(tempObj[ele][0]),
                  ele,
                  props.type
                ),
              });
            });
            setFormResult(mappedDataArray);
            dispatch({ type: "HIDE_LOADER" });
          }
        }
      })
      .catch((err) => {
        dispatch({ type: "HIDE_LOADER" });
        console.log("error:", err);
        errorHandler(err, navigate)
      });
  };

  useEffect(() => {
    if (uploadTrigger.trigger) {
      fetchCurrentData();
    }
  }, [uploadTrigger]);

  const handlePreviewClick = () => {

    if (props.type === "cmm") {
      return previewValidators(selectedFinancialYear, selectedQuarter, false, "", dispatch, pmsName)
    } else {
      return previewValidators(selectedFinancialYear, "", true, selectedHalfYearly, dispatch, pmsName)
    }
  };

  useEffect(() => {
    if (formResult.length > 0 && props.type == "cmm") {
      let tempArray = [];
      formResult.map((element) => {
        tempArray.push({ value: element.label, label: element.label });
      });
      setCompliance(tempArray);
      if (cmmType == "") {
        setSelectedCompliance(tempArray[0].value);
        dispatch({
          type: "selectedcmmType",
          cmmType: tempArray[0].value
        })
        setGridData(formResult.find((ele) => ele.label == tempArray[0].value));
        setFilteredRows(formResult.find((ele) => ele.label == tempArray[0].value))
      }
      else {
        setSelectedCompliance(cmmType);
        setGridData(formResult.find((ele) => ele.label == cmmType));
        setFilteredRows(formResult.find((ele) => ele.label == cmmType))
      }
    }
  }, [formResult]);

  useEffect(() => {
    setGridData(formResult.find((ele) => ele.label == selectedCompliance));
    setFilteredRows(formResult.find((ele) => ele.label == selectedCompliance))
    setSearchQuery("")
  }, [selectedCompliance]);


  const handleSearch = (event) => {
    const query = event.target.value;
    let filteredData;
    setSearchQuery(query);
    if (props.type == "cmm") {
      filteredData = gridData.rows.filter((row) => {
        if (row.cmm_type != "Investor Complaints") {
          const { particulars } = row;
          return Object.values({ particulars }).some((val) =>
            val?.toString().toLowerCase().includes(query.toLowerCase())
          );
        }
        else {
          const { complaint_source } = row;
          return Object.values({ complaint_source }).some((val) =>
            val?.toString().toLowerCase().includes(query.toLowerCase())
          );
        }
      });
    }
    setFilteredRows({ ...filteredRows, rows: filteredData });
  };
  useEffect(() => {
    // setRows([]);
    dispatch({ type: "fy_year", fy_year: selectedFinancialYear });
    dispatch({ type: "quarter", quarter: selectedQuarter });
    dispatch({ type: "half_year", half_year: selectedHalfYearly });
  }, [selectedFinancialYear, selectedQuarter, selectedHalfYearly]);

  return (
    <>
      <div className={Styles.FullBody}>
        <div className={Styles.navBody}>
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            <Link
              underline="hover"
              color="inherit"
              onClick={
                () => navigate("/app/welcome")
              }
            >
              Welcome
            </Link>
            <Link
              underline="hover"
              color="inherit"
              onClick={
                props.type === "cmm"
                  ? () => navigate("/app/cmmLayout")
                  : () => navigate("/app/hytrLayout")
              }
            >
              {props.type === "cmm" ? "CMM" : ""}
            </Link>
            <Link
              underline="hover"
              color="inherit"
            >
              {uploadType == "Form" ? "Fill Form" : "Upload File"}
            </Link>
          </Breadcrumbs>
          {formResult?.length > 0 && <TextField
            style={{
              height: "2rem",
              width: "clamp(10rem,20vw,30rem)",
            }}
            // id="outlined-basic"
            variant="outlined"
            placeholder="Search Table"
            // className="textfield_input"
            value={searchQuery}
            onChange={handleSearch}
          />}
        </div>
        <div className={Styles.HeaderBody}>
          <Grid container spacing={2} display="flex">
            <Grid item
              xs={12}
              sm={12}
              md={9}
              lg={9}>
              <SelectComponent
                selectedFinancialYear={selectedFinancialYear}
                setSelectedFinancialYear={setSelectedFinancialYear}
                selectedQuarter={selectedQuarter}
                setSelectedQuarter={setSelectedQuarter}
                selectedHalfYearly={selectedHalfYearly}
                // setSelectedHalfYearly={setSelectedHalfYearly}
                compliance={compliance}
                selectedCompliance={selectedCompliance}
                setSelectedCompliance={setSelectedCompliance} 
                />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              className={Styles.dataFormButtonTracker}
            >
              <button
                className={Styles.Preview}
                onClick={() => {
                  if (handlePreviewClick()) {
                                      
                    setFormResult([])
                    handleValidation();
                    
                  }
                }}
              >
                APPLY
              </button>
              <button
                className={Styles.Preview}
                style={{
                  backgroundColor: formResult.length > 0 ? "#154063" : "#808080",
                  cursor: formResult.length > 0 ? "pointer" : "default",
                  border: formResult.length > 0 ? "0.125rem solid #154063" : "0.125rem solid #808080",
                }}
                disabled={formResult.length > 0 ? false : true}
                onClick={handlePreviewData}
              >
                PREVIEW
              </button>
            </Grid>
          </Grid>
        </div>
        <div className={Styles.tableBody} style={{ position: "relative" }}>
          {uploadType === "File" && uploadFlag == true && (
            <UploadFile
              setFormResult={setFormResult}
              setUploadFlag={setUploadFlag}
              setIsPreviewClicked={setIsPreviewClicked}
              filePayload={
                props.type == "cmm"
                  ? {
                    fy_year: selectedFinancialYear,
                    quarter: selectedQuarter,
                  }
                  : {
                    fy_year: selectedFinancialYear,
                    half_year: selectedHalfYearly,
                  }
              }
              type={props.type}
              fetchCurrentData={fetchCurrentData}
            />
          )}
          {!isPreviewClicked && <Loader />}
          {gridData != undefined && finalSubmit == false ? (
            <CmmTable
              data={filteredRows}
              filePayload={
                props.type == "cmm"
                  ? {
                    fy_year: selectedFinancialYear,
                    quarter: selectedQuarter,
                    cmm_type: selectedCompliance,
                  }
                  : {
                    fy_year: selectedFinancialYear,
                    half_year: selectedHalfYearly,
                  }
              }
              setIsPreviewClicked={setIsPreviewClicked}
              setFormResult={setFormResult}
              type={props.type}
              handleValidation={handleValidation}
            />
          ) : <></>}
          {(pageLoading == false || pageLoading == undefined) && isPreviewClicked == false && formResult?.length == 0 && (
            <img
              className="image"
              src={logo}
              alt="Group 1000000833.png"
            />
          )}
        </div>
      </div>

      {
        <PreviewModal
          open={open}
          setOpen={setOpen}
          finalResult={previewData}
          type={props.type}
          setIsPreviewClicked={setIsPreviewClicked}
          setFinalSubmit={setFinalSubmit}
          setFormResult={setFormResult}
          setGridData={setGridData}
          setUploadFlag={setUploadFlag}
          setCompliance={setCompliance}
          setFilteredRows={setFilteredRows}
        />
      }
    </>
  );
};

export default CmmPage;
